import { Injectable } from '@angular/core';
import { App, AppInfo } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { ToastController } from '@ionic/angular';
import { NewEvaluationService } from './new-evaluation.service';

@Injectable({
  providedIn: 'root',
})
export class PreloaderService {
  public appInfo: AppInfo;
  public deploymentType: 'MOBILE' | 'WEB';
  constructor(
    private toast: ToastController,
    private newEvaluationService: NewEvaluationService,
  ) { }

  /**
   * Carga las tablas de apoyo
   */
  async init() {
    await this.newEvaluationService.init(); // Inicializando la nueva estructura de evaluación
    // this.loadProduct();
    this.setAppInfo();
  }

  // private loadProduct() {
  //   // this.subCategoryService.loadEntityInStore().catch((reject) => {
  //   //   this.toast.create({
  //   //     message: 'No fue posible crear la Base de datos para Subcategorias',
  //   //   });
  //   //   throw new Error(reject);
  //   // });
  //   // this.productService.loadEntityInStore().catch((reject) => {
  //   //   this.toast.create({
  //   //     message: 'No fue posible crear la Base de datos para Productos',
  //   //   });
  //   //   throw new Error(reject);
  //   // });
  //   // this.instrumentSelectedService.loadInstrumentInStorage().catch((reject) => {
  //   //   this.toast.create({
  //   //     message:
  //   //       'No fue posible crear la Base de datos para Instrumentos Seleccionados',
  //   //   });
  //   //   throw new Error(reject);
  //   // });
  // }

  // load app version on init
  private async setAppInfo() {
    if (Capacitor.getPlatform() !== 'web') {
      const appInfo: AppInfo = await App.getInfo();
      this.appInfo = appInfo;
      this.deploymentType = 'MOBILE';
    } else {
      this.deploymentType = 'WEB';
      this.appInfo = null;
    }

  }

}
